import React from 'react'
import { Box, Typography } from '@mui/material'

export const DetailRow = ({ label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <Typography variant='caption' sx={{ opacity: 0.75, mr: 1 }}>
      {label}:
    </Typography>
    <Typography variant='caption' fontWeight={600}>
      {value}
    </Typography>
  </Box>
)
